import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="calls"
export default class extends Controller {
  static targets = ["searchInput", "directionFilter", "statusFilter", "agentFilter", "dateStart", "dateEnd"];

  connect() {}

  search(_event) {
    this.submitFilters();
  }

  filterByDirection(_event) {
    this.submitFilters();
  }

  filterByStatus(_event) {
    this.submitFilters();
  }

  filterByAgent(_event) {
    this.submitFilters();
  }

  filterByDate(_event) {
    this.submitFilters();
  }

  clearFilters(event) {
    event.preventDefault();
    
    if (this.hasSearchInputTarget) this.searchInputTarget.value = "";
    if (this.hasDirectionFilterTarget) this.directionFilterTarget.value = "";
    if (this.hasStatusFilterTarget) this.statusFilterTarget.value = "";
    if (this.hasAgentFilterTarget) this.agentFilterTarget.value = "";
    if (this.hasDateStartTarget) this.dateStartTarget.value = "";
    if (this.hasDateEndTarget) this.dateEndTarget.value = "";
    
    this.submitFilters();
  }

  submitFilters() {
    const params = new URLSearchParams();
    
    if (this.hasSearchInputTarget && this.searchInputTarget.value) {
      params.append("search", this.searchInputTarget.value);
    }
    
    if (this.hasDirectionFilterTarget && this.directionFilterTarget.value) {
      params.append("direction", this.directionFilterTarget.value);
    }
    
    if (this.hasStatusFilterTarget && this.statusFilterTarget.value) {
      params.append("status", this.statusFilterTarget.value);
    }
    
    if (this.hasAgentFilterTarget && this.agentFilterTarget.value) {
      params.append("agent_id", this.agentFilterTarget.value);
    }
    
    if (this.hasDateStartTarget && this.dateStartTarget.value) {
      params.append("date_start", this.dateStartTarget.value);
    }
    
    if (this.hasDateEndTarget && this.dateEndTarget.value) {
      params.append("date_end", this.dateEndTarget.value);
    }
    
    // Use Turbo to update the page
    const url = `${window.location.pathname}?${params.toString()}`;
    Turbo.visit(url);
  }

  exportCSV(event) {
    event.preventDefault();
    
    const params = new URLSearchParams(window.location.search);
    params.append("format", "csv");
    
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }

  initiateCall(event) {
    const customerId = event.currentTarget.dataset.customerId;

    // Open modal or redirect to new call page
    window.location.href = `/calls/new?customer_id=${customerId}`;
  }
}

